import { render, staticRenderFns } from "./BarraDePercentual.vue?vue&type=template&id=36d89888&scoped=true&"
import script from "./BarraDePercentual.vue?vue&type=script&lang=ts&"
export * from "./BarraDePercentual.vue?vue&type=script&lang=ts&"
import style0 from "./BarraDePercentual.vue?vue&type=style&index=0&id=36d89888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d89888",
  null
  
)

export default component.exports